import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { LanguageSelectorService } from '@rxap/ngx-localize';
import { iirdsStore } from '../stores/iirds.store';
import { productStore } from '../stores/product.store';

export const productsGuard: CanActivateFn = async (route, state) => {
  console.debug('productsGuard');
  const product = inject(productStore);
  const iirds = inject(iirdsStore);
  const languageSelectorService = inject(LanguageSelectorService);

  let langauges = product.languages();
  if (langauges.length === 0) {
    langauges = Object.keys(languageSelectorService.languages());
  }
  iirds.container().metadata.rdf.package.languageList = langauges;

  return true;
};
